module.exports = __webpack_public_path__ + "static/10-6520e3c91827ed9c9465eb8d3909d6b6.jpg";